$(document).ready(function(){

  $('#myModal').modal('show');
$('.map-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 3,
      centerMode: true, // Enable center mode
      centerPadding: '30px', // Adjust this value for padding
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [{
          breakpoint: 1024,
          settings: {
              slidesToShow: 3,
              centerPadding: '20px' // Adjust for smaller screens
          }
      }, {
          breakpoint: 768,
          settings: {
              slidesToShow: 3,
              centerPadding: '30px' // Adjust for mobile
          }
      }, {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              centerPadding: '0px' // Adjust for very small screens
          }
      }]
    });
  



  $('.vertical-slider').slick({
     vertical: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: false,
    dots: false
  });
  $('.hero-slider').slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  $('.single-item').slick({
    slidesToShow: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                slidesToShow: 1
            }
        }
    ]
});
  //  $('.product__media-list').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: true,
  //   speed: 300,
  //   infinite: true,
  //   autoplaySpeed: 5000,
  //   autoplay: true,
  //   prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-left.png?v=1715841926" class="arrow-left">',
  //   nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-right.png?v=1715841927" class="arrow-right">',
  //   responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         arrows: false,
  //         slidesToShow: 1,
  //       }
  //     }
  //   ]
  // });
 $('.benefit-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-left.png?v=1715841926" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-right.png?v=1715841927" class="arrow-right">',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 1,
        }
      }
    ]
  });
  
  $('.we-stand-list').slick({
    slidesToShow:4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0864/6495/4687/files/angle-left.svg?v=1709211951" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0864/6495/4687/files/angle-right.svg?v=1709211950" class="arrow-right">',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: false,
        }
      }
    ]
  });

  $('.loved-one').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-left.png?v=1715841926" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-right.png?v=1715841927" class="arrow-right">',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });


  $('.best-seller-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-left.png?v=1715841926" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/arrow-right.png?v=1715841927" class="arrow-right">',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  $('.customer-list').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0864/6495/4687/files/angle-left.svg?v=1709211951" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0864/6495/4687/files/angle-right.svg?v=1709211950" class="arrow-right">',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
  $('.store-location-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/Arrow_L.png?v=1715856617" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0699/9284/1461/files/Arrow_R.png?v=1715856617" class="arrow-right">',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
$('.topbar-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
});